import React, { useState } from "react";
import "react-date-range/dist/styles.css"; // main css file
import "react-date-range/dist/theme/default.css"; // theme css file
import "./CustomDateRangeMobile.scss";

import { DateRange } from "react-date-range";
import { addDays } from "date-fns";
import format from "date-fns/format";
import {
  Input,
  Popover,
  PopoverTrigger,
  PopoverContent,
  PopoverBody,
} from "@chakra-ui/react";

interface CustomDateRangeProps {
  startDate :any;
  endDate:any;
  onStartDateChange: (startDate: Date) => void;
  onEndDateChange: (endDate: Date) => void;
}

export default function CustomDateRangeMobile({
  startDate,
  endDate,
  onStartDateChange,
  onEndDateChange,
}: CustomDateRangeProps): JSX.Element {

  return (
    <Popover placement="auto-end">
      <>
        <PopoverTrigger>
          <Input
            name="datePickerMobile"
            value={`${format(startDate, "dd/MM/yyyy")} to ${format(
              endDate,
              "dd/MM/yyyy"
            )}`}
            width={{ base: "14rem", lg: "18rem" }}
            textAlign="center"
            p={0}
          />
        </PopoverTrigger>
        <PopoverContent width="auto">
          <PopoverBody>
            <DateRange
              onChange={(item: any) => {
                onStartDateChange(item.selection.startDate);
                onEndDateChange(item.selection.endDate);
              }}
              editableDateInputs={true}
              moveRangeOnFirstSelection={false}
              ranges={[
                {
                  startDate: startDate,
                  endDate: endDate,
                  key: "selection",
                },
              ]}
              months={1}
              direction="horizontal"
              className="calendarElementMobile"
              rangeColors={["#38B2AC"]}
            />
          </PopoverBody>
        </PopoverContent>
      </>
    </Popover>
  );
}
